var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 15.6663C4.04634 15.6663 0.833008 12.453 0.833008 8.49967C0.833008 4.54634 4.04634 1.33301 7.99967 1.33301C11.953 1.33301 15.1663 4.54634 15.1663 8.49967C15.1663 12.453 11.953 15.6663 7.99967 15.6663ZM7.99967 2.33301C4.59967 2.33301 1.83301 5.09967 1.83301 8.49967C1.83301 11.8997 4.59967 14.6663 7.99967 14.6663C11.3997 14.6663 14.1663 11.8997 14.1663 8.49967C14.1663 5.09967 11.3997 2.33301 7.99967 2.33301Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 9H6.33301C6.05967 9 5.83301 8.77333 5.83301 8.5C5.83301 8.22667 6.05967 8 6.33301 8H10.333C10.6063 8 10.833 8.22667 10.833 8.5C10.833 8.77333 10.6063 9 10.333 9Z",
    fill: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6663 11.0003C7.53964 11.0003 7.41297 10.9536 7.31297 10.8536L5.31297 8.85362C5.11964 8.66029 5.11964 8.34029 5.31297 8.14695L7.31297 6.14695C7.5063 5.95362 7.8263 5.95362 8.01964 6.14695C8.21297 6.34029 8.21297 6.66029 8.01964 6.85362L6.37297 8.50029L8.01964 10.147C8.21297 10.3403 8.21297 10.6603 8.01964 10.8536C7.91964 10.9536 7.79297 11.0003 7.6663 11.0003Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.e96fa9bfa623b560a79aabc2f798927d.svg";
export { ForwardRef as ReactComponent };